import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-599c3f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("创建类别")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("绑定")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确定")

import {ref, Ref, reactive, onBeforeMount, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'
interface Option {
  label: string
  key: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    categoryType: null
  },
  setup(__props: any) {

const props = __props as {
  categoryType: string
}

let {
  // 获取类别
  'GET/order_categorys': fetchList,
  // 新增订单列别
  'POST/order_categorys': addOrder_categorysApi,
  // 获取类别中绑定和未绑定的列表
  'GET/order_category_binds': order_category_bindsApi,
  // 获取未绑定的数据
  'GET/order_category_binds/unbind': unbindListApi,
  // 订单类别绑定
  'POST/order_category_binds': bindsApi,
  // 修改订单名称
  'PATCH/order_categorys': editOrder_categorysApi,
} = Api


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchConfig = ref([])

const isLoadingUnbind = ref<boolean>(false)
let unbindTable = ref([])
const searchHandle = () => {
  fetchData({ category: props.categoryType })
  // 获取未绑定类别
  isLoadingUnbind.value = true
  unbindListApi({ category: props.categoryType }).then(({unBind}: any) => {
    unbindTable.value = unBind.map((str: string) => ({name: str}))
  }).finally(() => {
    isLoadingUnbind.value = false
  })
}
searchHandle()
// 获取绑定和未绑定
const getBindList = async (id: string) => {
  let {bind, unBind} = await order_category_bindsApi({category: props.categoryType, categoryId: id})
  return {
    unbindList: unBind.map((str: string, index: number) => ({label: str, key: str})),
    bindList: bind.map((str: string, index: number) => ({label: str, key: str})),
  }
}
// 添加
const addConfig = ref([
  {
    label: '类别名称',
    value: '',
    upKey: 'name',
    props: {maxlength: 50},
    rule: [{ required: true, message: '请输入类别名称', trigger: 'change' }]
  }
])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    await addOrder_categorysApi({
      ...params,
      category: props.categoryType
    })
    ElMessage.success('成功')
    addFg.value = false
    searchHandle()
  })
}

// 绑定
const bindFg = ref<boolean>(false)
let bindName = ref<Option[]>([])
let unbindName = ref<string[]>([])

let pendingRow: {id: number | null} = reactive({id: null})
const bindingHandle = (row: any) => {
  Object.assign(pendingRow, row)

  MI_identify.value = true
  getBindList(row.id).then(({ bindList, unbindList }: any) => {
    // data ,已绑定
    bindName.value = bindList.concat(unbindList)
    unbindName.value = unbindList.map((e: Option) => e.label)
    
    bindFg.value = true
  }).finally(() => {
    MI_identify.value = false
  })
}

const submitBtnLoad = ref<boolean>(false)
const submitBinding = () => {
  let arr: string[] = bindName.value.reduce((arr: string[], item: Option) => {
    if(! unbindName.value.includes(item.label)){
      arr.push(item.label)
    }
    return arr
  }, [])
  
  submitBtnLoad.value = true
  bindsApi({
    orderCategoryId: pendingRow.id as number,
    bindNames: arr
  }).then(() => {
    ElMessage.success('成功')
    bindFg.value = false
    searchHandle()
  })
  .finally(() => {
    submitBtnLoad.value = false
  })
}

// 删除
const editFg = ref<boolean>(false)
const editHandle = (row: any) => {
  MI_modifyForm(row, addConfig, editFg, async(params: any) => {
    await editOrder_categorysApi({
      ...params,
      category: props.categoryType,
      id: row.id
    })
    ElMessage.success('修改成功')
    editFg.value = false
    searchHandle()
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_transfer = _resolveComponent("el-transfer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: addHandle
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      icon: "refresh",
      type: "info",
      onClick: searchHandle
    }),
    _createVNode(_component_el_row, {
      gutter: 10,
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              border: "",
              data: _unref(MI_tableData),
              height: _unref(MI_height) + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "订单类别名称",
                  prop: "name",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (editHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          type: "primary",
                          onClick: ($event: any) => (bindingHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "height"])), [
              [_directive_loading, _unref(MI_identify)]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 7 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              border: "",
              data: _unref(unbindTable),
              height: _unref(MI_height) + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "未绑定类别名称",
                  prop: "name",
                  "show-overflow-tooltip": ""
                })
              ]),
              _: 1
            }, 8, ["data", "height"])), [
              [_directive_loading, isLoadingUnbind.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 9 })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "创建类别",
      width: "400px",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑类别",
      width: "400px",
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editFg).value = $event))
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: '绑定类别：' + _unref(pendingRow).name,
      top: "5vh",
      width: "930px",
      modelValue: bindFg.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((bindFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (bindFg.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitBinding,
          loading: submitBtnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_transfer, {
          data: _unref(bindName),
          modelValue: _unref(unbindName),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(unbindName) ? (unbindName).value = $event : unbindName = $event)),
          titles: ['已绑定', '未绑定']
        }, null, 8, ["data", "modelValue"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})